export interface ModalsShowActionType {
  type: '@modals/SHOW';
  payload: string;
}

export const showModal = (modalId: string): ModalsShowActionType => ({
  type: '@modals/SHOW',
  payload: modalId,
});
